import { useCallback } from 'react'

import { experimentsTrackEvent } from '../eventTracking'
import { useGetExperiment } from '../hooks'
import { EXPERIMENT_NAME_REMOVE_BANNERS } from '../model/EXPERIMENT_NAME'

export const useExperimentRemoveBannersTracking = (
  trackEvent: string,
): (() => void) => {
  const removeBannersExperiment = useGetExperiment(
    EXPERIMENT_NAME_REMOVE_BANNERS,
  )

  return useCallback((): void => {
    if (!removeBannersExperiment.isEnabled) {
      return
    }
    experimentsTrackEvent(trackEvent)
  }, [removeBannersExperiment.isEnabled, trackEvent])
}
